export const getProjects = (state) => state.projects;